import { SVGProps } from 'react';

const IcClose = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.1825 3.81727C20.6344 4.26917 20.6344 5.00185 20.1825 5.45376L5.45409 20.1822C5.00219 20.6341 4.26951 20.6341 3.8176 20.1822C3.3657 19.7303 3.3657 18.9976 3.8176 18.5457L18.546 3.81727C18.9979 3.36536 19.7306 3.36536 20.1825 3.81727Z'
        fill={props.fill || '#232F3E'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.8175 3.81727C4.2694 3.36536 5.00208 3.36536 5.45399 3.81727L20.1824 18.5457C20.6343 18.9976 20.6343 19.7303 20.1824 20.1822C19.7305 20.6341 18.9978 20.6341 18.5459 20.1822L3.8175 5.45376C3.36559 5.00185 3.36559 4.26917 3.8175 3.81727Z'
        fill={props.fill || '#232F3E'}
      />
    </svg>
  );
};

export default IcClose;
